<template>
  <a-modal
    v-model="visible"
    :title="
      resource ? 'Cập nhật câu hỏi - trả lời' : 'Thêm mới câu hỏi - trả lời'
    "
    :maskClosable="false"
    @cancel="handleClose"
  >
    <a-form-model :model="form" :rules="rules" ref="form">
      <a-form-model-item class="mb-5" label="Câu hỏi" prop="question">
        <a-textarea v-model="form.question" :rows="3" placeholder="Câu hỏi" />
      </a-form-model-item>
      <a-form-model-item class="mb-5" label="Câu trả lời" prop="answer">
        <a-textarea v-model="form.answer" :rows="5" placeholder="Câu trả lời" />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleClose"> Đóng </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="callingAPI"
        @click="handleSubmit"
      >
        Submit
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import {
  createQuestionAnswer,
  updateQuestionAnswer,
} from "@/services/landing-page/contact/question-answer";
export default {
  name: "ControllerContactQuestionAnswer",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      callingAPI: false,
      form: {
        question: "",
        answer: ""
      },
      rules: {
        question: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        answer: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    visible() {
      if (this.resource) {
        this.form.question = this.resource.question
        this.form.answer = this.resource.answer;
      }
    }
  },
  methods: {
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            const data = {
              question: this.form.question,
              answer: this.form.answer,
              active: this.resource ? this.resource.active : 1
            }
            if (this.resource) {
              await updateQuestionAnswer(this.resource.id, data);
            } else {
              await createQuestionAnswer(data);
            }
            this.callingAPI = false;
            this.$emit('reload')
            this.handleClose()
            
            let message;
            message = this.resource
              ? "Cập nhật thành công"
              : "Thêm mới thành công";
            this.$notification.success({
              message: "Thành công",
              description: message,
            });
          } catch (error) {
            console.log(error);
            this.callingAPI = false
            let message = this.resource
              ? "Cập nhật thất bại"
              : "Thêm mới thất bại";
            this.$notification.error({
              message: "Thất bại",
              description: message,
            });
          }
        }
      });
    },

    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>